/**
 * Header behaviour.
 *
 * The navigation itself is CSS-first: submenus open on :hover and
 * :focus-within, every level is a real <a href>, and the whole menu works with
 * JavaScript disabled. This file adds only the two things CSS cannot express.
 *
 * Listeners are bound at document/window level rather than to header nodes, so
 * they survive the theme editor re-rendering the section and any Section
 * Rendering API swap — no re-initialisation needed.
 */
(function () {
  'use strict';

  /* ------------------------------------------------- Escape closes a panel */

  /**
   * :focus-within keeps a submenu open for keyboard users, which means Escape
   * cannot close it by moving focus — focus has to stay on the parent link.
   * The `data-closed` flag overrides :focus-within until the pointer or focus
   * genuinely leaves the item.
   */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const panel = event.target.closest('.header-nav__panel');
    if (!panel) return;

    const item = panel.closest('.header-nav__item');
    if (!item) return;

    item.setAttribute('data-closed', '');
    const parentLink = item.querySelector('.header-nav__link');
    if (parentLink) parentLink.focus();
  });

  // Clear the flag once the item is genuinely left, so hover works again.
  document.addEventListener('focusout', (event) => {
    const item = event.target.closest('.header-nav__item[data-closed]');
    if (item && !item.contains(event.relatedTarget)) {
      item.removeAttribute('data-closed');
    }
  });

  document.addEventListener('pointerleave', (event) => {
    const item = event.target.closest && event.target.closest('.header-nav__item[data-closed]');
    if (item) item.removeAttribute('data-closed');
  }, true);

  /* ----------------------------------------------------- sticky shadow */

  const header = document.querySelector('.header[data-sticky="true"]');
  if (header) {
    // A sentinel above the header is cheaper than a scroll listener and does
    // not run script on every frame.
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;';
    header.parentNode.insertBefore(sentinel, header);

    new IntersectionObserver(
      ([entry]) => {
        header.toggleAttribute('data-scrolled', !entry.isIntersecting);
      },
      { threshold: 0 }
    ).observe(sentinel);
  }
})();
